/** @jsx jsx */
import type { ReactNode } from 'react';
import { jsx } from '@balance-web/core';
import type { WithDataAttributeProp } from '@balance-web/core';

import type { ItemBaseProps } from './ItemBase';
import { ItemBase } from './ItemBase';
import { RadioItemContainer } from './radix-styled-components';

export type RadioItemProps = WithDataAttributeProp<
  {
    value: string;
    children: ReactNode;
  } & ItemBaseProps
>;

export const RadioItem = ({
  value,
  children,
  data,
  ...props
}: RadioItemProps) => {
  return (
    <RadioItemContainer data={data} disabled={props.disabled} value={value}>
      <ItemBase {...props}>{children}</ItemBase>
    </RadioItemContainer>
  );
};
